
import { ForumLink } from '@/models/ForumLink';
import { RawLocation } from 'vue-router';
import { PropType } from 'vue';

export default {
  name: 'BCXParticipateLinks',
  props: {
    linkList: { type: Array as PropType<ForumLink[]>, default: () => [] },
  },
  methods: {
    getThreadLink(link: ForumLink): RawLocation {
      const { forumId, groupId, forumThreadId } = link;
      return { name: 'thread', params: { forumId, groupId, threadId: forumThreadId } };
    },
  }
};
